import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import { store } from '../../../../store/store';
import AclContextProvider from '../../../Acl/Components/AclContextProvider';
import EArchiveWrapper from '../EArchiveWrapper/EArchiveWrapper';
import { SelectUsersContextProvider } from '../../Services/SelectUsersContext';
import { GroupsContextProvider } from '../../Services/GroupsContext';

loadDOMComponent({
	selector: 'react-e-archive-wrapper',
	callback: ({ container, context, props }: any) => {
		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<SelectUsersContextProvider>
							<GroupsContextProvider>
								<EArchiveWrapper />
							</GroupsContextProvider>
						</SelectUsersContextProvider>
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
